import type { ReactNode } from "react";

import Container from "./Container";

const Alert = ({
  headline,
  details,
}: {
  headline: string;
  details?: ReactNode;
}) => (
  <Container purpose="alert">
    <h1>{headline}</h1>
    <Container>{details}</Container>
  </Container>
);

export default Alert;
